import { ProvidersShell } from './ProvidersShell';
import { ProviderHealthPanel } from './ProviderHealthPanel';

/** /dev-console/providers/health — per-provider reliability. */
export function ProviderHealthPage() {
  return (
    <ProvidersShell>
      <ProviderHealthPanel />
    </ProvidersShell>
  );
}
